module.exports = __webpack_public_path__ + "static/media/turkestan_1.580b5652.jpg";